import {
  getLpuItemInterface,
  getDoctorsItemInterface,
  getServicesItemInterface,
  getDoctorsLpuItemInterface,

  getLpuStorageInterface,
  getDoctorsStorageInterface,
  getServicesStorageInterface,
  getDoctorsLpuStorageInterface,
} from 'www/modules/Schedule/models'

import { PAGE_TYPE_DATA } from 'www/modules/Schedule/constants'

type PageType = typeof PAGE_TYPE_DATA[keyof typeof PAGE_TYPE_DATA]

type PageDataInterface =
  | {
    itemsInterface: ReturnType<typeof getLpuItemInterface>
    storageInterface: ReturnType<typeof getLpuStorageInterface>
  }
  | {
    itemsInterface: ReturnType<typeof getDoctorsItemInterface>
    storageInterface: ReturnType<typeof getDoctorsStorageInterface>
  }
  | {
    itemsInterface: ReturnType<typeof getServicesItemInterface>
    storageInterface: ReturnType<typeof getServicesStorageInterface>
  }
  | {
    itemsInterface: ReturnType<typeof getDoctorsLpuItemInterface>
    storageInterface: ReturnType<typeof getDoctorsLpuStorageInterface>
  }

/**
 * @description
 * Возвращает нужный интерфейс данных страницы в зависимости от переданного аргумента
 *
 * @param pageType - одна из констант 'PAGE_TYPE_DATA'
 * @returns объект с 2 интерфейсами
 */

const getPageDataInterface = (pageType: PageType): PageDataInterface | undefined => {
  switch (pageType) {
    case PAGE_TYPE_DATA.lpu:
      return {
        itemsInterface: getLpuItemInterface(),
        storageInterface: getLpuStorageInterface(),
      }
    case PAGE_TYPE_DATA.doctors:
      return {
        itemsInterface: getDoctorsItemInterface(),
        storageInterface: getDoctorsStorageInterface(),
      }
    case PAGE_TYPE_DATA.services:
      return {
        itemsInterface: getServicesItemInterface(),
        storageInterface: getServicesStorageInterface(),
      }
    case PAGE_TYPE_DATA.doctorsLpu:
      return {
        itemsInterface: getDoctorsLpuItemInterface(),
        storageInterface: getDoctorsLpuStorageInterface(),
      }
    default:
      return undefined
  }
}

export default getPageDataInterface
